import React, { useState } from "react";
import { Get, Remove, Set } from "../../../../../Request";

export const useShargeUser = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchType, setsearchType] = useState("fullname");
  const [modal, setModal] = useState({
    sharge: false,
    sure: false,
  });
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [price, setPrice] = useState(0);
  const getData = async (pageNumber, limit = 15) => {
    setLoading(true);
    return await Get({
      url: "/clientmanagment/show_list",
      data: {
        limit: limit,
      },
      page: pageNumber,
    }).then(data => {
      setList(data);
      setLoading(false);
    });
  };
  const dataSearch = async (data, limit = 15, page = null) => {
    setLoading(true);
    return await Get({
      url: "/clientmanagment/show_list",
      data: {
        limit: limit,
        ...data,
      },
      page: page,
    }).then(data => {
      setLoading(false);
      setList(data);
    });
  };

  const handlerSearch = data => {
    dataSearch({ [searchType]: data });
  };

  const shargeWallet = async () => {
    setLoadingBtn(true);
    return await Set({
      url: "/clientmanagment/shargewallet",
      data: {
        price: price,
        user_id: modal.sharge,
      },
    }).then(() => {
      setPrice(0);
      getData();
      setLoadingBtn(false);
    });
  };

  return {
    list,
    loading,
    getData,
    dataSearch,
    searchType,
    setsearchType,
    handlerSearch,
    modal,
    setModal,
    shargeWallet,
    setPrice,
    price,
    loadingBtn,
    setLoadingBtn,
  };
};
